import React from 'react';
import { Heart, Instagram, Twitter, Mail, Video } from 'lucide-react';

const BunnyFooter = () => {
  return (
    <footer className="bunny-section-dark border-t-2 border-pink-400">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <h3 className="text-3xl font-serif bunny-headline text-white mb-4">
              Waisted <span className="bunny-accent-pink">Bunny</span>
            </h3>
            <p className="text-gray-400 font-sans text-sm leading-relaxed mb-6 max-w-md">
              Fashion-forward shapewear for the modern, trend-conscious woman. Where confidence meets cutting-edge style.
            </p>
            <div className="flex gap-4">
              <a href="https://instagram.com/thewaistedbunny" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-pink-400 rounded-full flex items-center justify-center transition-colors" aria-label="Instagram">
                <Instagram className="w-6 h-6 text-white" />
              </a>
              <a href="https://instagram.com/thewaistedbunny" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-pink-400 rounded-full flex items-center justify-center transition-colors" aria-label="TikTok">
                <Video className="w-6 h-6 text-white" />
              </a>
              <a href="https://instagram.com/thewaistedbunny" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-white/10 hover:bg-pink-400 rounded-full flex items-center justify-center transition-colors" aria-label="Twitter">
                <Twitter className="w-6 h-6 text-white" />
              </a>
              <a href="mailto:hello@waistedbunny.com" className="w-12 h-12 bg-white/10 hover:bg-pink-400 rounded-full flex items-center justify-center transition-colors" aria-label="Email">
                <Mail className="w-6 h-6 text-white" />
              </a>
            </div>
          </div>

          {/* Shop Column */}
          <div>
            <h4 className="font-sans font-bold text-sm tracking-widest mb-4 text-white">SHOP</h4>
            <ul className="space-y-3 text-sm font-sans text-gray-400 font-medium">
              <li><a href="#" className="hover:text-pink-400 transition-colors">All Products</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Waist Trainers</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Shapewear</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">New Arrivals</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Best Sellers</a></li>
            </ul>
          </div>

          {/* Support Column */}
          <div>
            <h4 className="font-sans font-bold text-sm tracking-widest mb-4 text-white">SUPPORT</h4>
            <ul className="space-y-3 text-sm font-sans text-gray-400 font-medium">
              <li><a href="#" className="hover:text-pink-400 transition-colors">Contact Us</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Size Guide</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Shipping Info</a></li>
              <li><a href="#" className="hover:text-pink-400 transition-colors">Returns</a></li>
              <li><a href="#faq" className="hover:text-pink-400 transition-colors">FAQ</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm font-sans text-gray-500">
            © 2025 Waisted Bunny. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm font-sans text-gray-500 font-medium">
            <a href="#" className="hover:text-pink-400 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-pink-400 transition-colors">Terms of Service</a>
          </div>
        </div>

        {/* Love note */}
        <div className="mt-8 text-center">
          <p className="text-sm font-sans text-gray-600 flex items-center justify-center gap-2">
            Made with <Heart className="w-4 h-4 fill-pink-400 text-pink-400" /> for fashion-forward women everywhere
          </p>
        </div>
      </div>
    </footer>
  );
};

export default BunnyFooter;
